import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface WorkflowInstanceState {
  selectedStepInstanceId: string | null;
}

const initialState: WorkflowInstanceState = {
  selectedStepInstanceId: null,
};

// SLICE
export const workflowInstanceSlice = createSlice({
  name: "workflowInstance",
  initialState,
  reducers: {
    setSelectedStepInstanceId: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.selectedStepInstanceId = action.payload;
    },
  },
});

// ACTIONS
export const { setSelectedStepInstanceId } = workflowInstanceSlice.actions;

// REDUCER
export const workflowInstanceReducer = workflowInstanceSlice.reducer;

// SELECTORS
export const selectSelectedStepInstanceId = (state: {
  workflowInstance: WorkflowInstanceState;
}) => state.workflowInstance.selectedStepInstanceId;
